// src/firebase/uploadHelper.js
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { v4 as uuidv4 } from "uuid";

const storage = getStorage();

/**
 * Upload any proof/document/image to Firebase Storage safely.
 * Accepts all common MIME types — fallback to octet-stream if missing.
 */
export async function uploadProofFile(file, folder = "proofs") {
  if (!file) return null;

  try {
    const fileId = uuidv4();
    const safeName = file.name.replace(/[^\w.\-()]/g, "_"); // avoid weird chars
    const fileRef = ref(storage, `${folder}/${fileId}_${safeName}`);

    // ✅ Ensure Firebase always gets a valid contentType
    const metadata = {
      contentType: file.type || "application/octet-stream",
    };

    const snapshot = await uploadBytes(fileRef, file, metadata);
    const url = await getDownloadURL(snapshot.ref);
    return url;
  } catch (err) {
    console.error("❌ uploadProofFile error:", err);
    alert("Upload failed. Please check your file type and try again.");
    return null;
  }
}
